<template>
  <section>
    <ul class="filters-list">
      <li
        :class="{
          'router-link-active-parent': $route.name == 'ArchiveDataCases',
        }"
      >
        <router-link
          :to="{ name: 'ArchiveDataCases', query: this.$route.query }"
        >
          CASES
          <span class="active-icon">
            <img src="@/assets/images/caret-down-fill.svg" alt="" /> </span
        ></router-link>
      </li>
      <li>
        <router-link
          :to="{ name: 'ArchiveDataOrders', query: this.$route.query }"
        >
          ORDERS
          <span class="active-icon">
            <img src="@/assets/images/caret-down-fill.svg" alt="" /> </span
        ></router-link>
      </li>
    </ul>
  </section>
</template>
